import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Button, TextField, Grid, FormLabel } from '@mui/material';
import GlobalDialogContent from '../GlobalDialogContent';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../redux/reducer/snackbarSlice';
import { CommitmentStatusUpdate } from '../../../utils/services/project/project';
import { closeDialog } from '../../../redux/reducer/dialogSlice';
import { RootState } from '../../../redux/store';
import { setModuleRefresh } from '../../../redux/reducer/registration/RefreshSlice';
import "react-quill/dist/quill.snow.css";
import "draft-js/dist/Draft.css";


const RejectCommit = () => {
    const dispatch = useDispatch();
    const projectData = useSelector((state: RootState) => state.dialog.payload);

    const formik = useFormik({
        initialValues: {
            unitsCommitted: projectData?.no_of_unit,
            costPerUnit: projectData?.cost,
            totalCommitment: projectData?.total_implementation,
            comment: ''
        },
        validationSchema: Yup.object({
            unitsCommitted: Yup.number().min(1, 'Minimum 1 unit required').required('Required'),
            costPerUnit: Yup.number().min(0, 'Cost per unit must be positive').required('Required'),
            totalCommitment: Yup.string(),
            comment: Yup.string().required("Comment is Required.!")
            
        }),
        onSubmit: async (values, { setSubmitting }) => {
            if (projectData?.id) {
                const reqPayload = {
                    request_id: projectData?.id,
                    user_id: projectData?.user_id,
                    status: "rejected",
                    no_of_unit: values.unitsCommitted,
                    cost: values.costPerUnit,
                    total_implementation: values.totalCommitment,
                    comment: values.comment
                };

                const { code } = await CommitmentStatusUpdate(reqPayload);

                if (code === 200) {
                    dispatch(setModuleRefresh({ moduleName: 'rejectCommitment', refresh: true }));
                    dispatch(closeDialog());
                    dispatch(showSnackbar({ type: "success", message: "Status updated successfully!" }));
                } else {
                    dispatch(showSnackbar({ type: "error", message: "Failed to update status" }));
                }
            }
        }
    });
    
    return (

        <>
            <form onSubmit={formik.handleSubmit}>
                <GlobalDialogContent
                    dialogBody={
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    label="No. of Units Committed"
                                    name="unitsCommitted"
                                    type="text"
                                    size='small'
                                    value={formik.values.unitsCommitted}
                                    InputProps={{
                                        disabled: true,
                                    }}
                                    onChange={(e) => {
                                        let value = e.target.value.replace(/[^0-9]/g, "");
                                        formik.setFieldValue(e.target.name, value);
                                    }}
                                    error={formik.touched.unitsCommitted && Boolean(formik.errors.unitsCommitted)}
                                    helperText={formik.touched.unitsCommitted && Boolean(formik.errors.unitsCommitted)}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    label="Cost per Unit"
                                    name="costPerUnit"
                                    type="text"
                                    size='small'
                                    value={formik.values.costPerUnit}
                                    InputProps={{
                                        disabled: true,
                                    }}
                                    onChange={(e) => {
                                        let value = e.target.value.replace(/[^0-9]/g, "");
                                        formik.setFieldValue(e.target.name, value);
                                        formik.setFieldValue('totalCommitment', Number(value) * Number(formik.values.unitsCommitted));
                                    }}
                                    error={formik.touched.costPerUnit && Boolean(formik.errors.costPerUnit)}
                                    helperText={formik.touched.costPerUnit && Boolean(formik.errors.costPerUnit)}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    label="Total Commitment"
                                    name="totalCommitment"
                                    type="text"
                                    InputProps={{
                                        disabled: true,
                                    }}
                                    autoFocus
                                    size='small'
                                    value={formik.values.totalCommitment}

                                />
                            </Grid>

                            <Grid item xs={12}  sm={12} md={12} sx={{mt: 1}}>
                                <FormLabel>Remarks: <span style={{color: 'red'}}>*</span> </FormLabel>
                                <TextField
                                        name="comment"
                                        value={formik.values.comment}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.comment && Boolean(formik.errors.comment)}
                                        helperText={formik.touched.comment && formik.errors.comment}
                                        placeholder="Enter Comments"
                                        multiline
                                        rows={3}
                                        size="small"
                                        fullWidth
                                    />
                            </Grid>
                        </Grid>
                    }
                    dialogFooter={
                        <>
                            <Button type="submit" variant="contained" color="primary">
                                Reject
                            </Button>
                        </>
                    }
                />
            </form>

        </>
    );
};

export default RejectCommit;


